import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { getRequiredBusinessDocuments } from "../../pages/Onboarding/redux/actions";
import * as Sentry from "@sentry/react";

type Props = {
  businessTypeId?: number | string;
  businessCountry: string;
};

type RequiredDocsDetails = {
  id: number | string;
  document: string;
};

export const useRequiredDocs = ({ businessTypeId, businessCountry }: Props) => {
  const [requiredDocs, setRequiredDocs] = useState<RequiredDocsDetails[]>([]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchRequiredDocuments = async () => {
      let country;
      if (["NG", "KE", "GH"].includes(businessCountry)) {
        country = businessCountry;
      } else {
        country = "INTERNATIONAL";
      }
      const action = await dispatch(
        getRequiredBusinessDocuments({ businessTypeId, country }),
      );

      if (getRequiredBusinessDocuments.fulfilled.match(action)) {
        const listOfRequiredDocs = action.payload
          .filter((item) => {
            return item.isMandatory;
          })
          .map((item: any) => ({
            id: item.businessDocument.id,
            document: item.businessDocument.document,
          }));
        setRequiredDocs(listOfRequiredDocs);
      } else if (getRequiredBusinessDocuments.rejected.match(action)) {
        Sentry.captureException(action);
      }
    };

    fetchRequiredDocuments();
  }, [businessTypeId]);

  return { requiredDocs };
};
